import { baseUrl } from "../services/HttpServices";

export const getCompanyLogoUrl = (companyLogoUrl) => {
  if (!companyLogoUrl) return "";

  const base = baseUrl || "";
  const normalizedBaseUrl = base.endsWith("/") ? base.slice(0, -1) : base;

  return `${normalizedBaseUrl}/api/companies/logo?url=${encodeURIComponent(
    companyLogoUrl,
  )}`;
};
